import { render } from "./NoOrders.vue?vue&type=template&id=b8ca43fe&scoped=true"
const script = {}

import "./NoOrders.vue?vue&type=style&index=0&id=b8ca43fe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8ca43fe"]])

export default __exports__